import { eventBus } from '@ssv-website/hooks';

interface PageModuleEventMap {
  onScrollForumModule: { isSubForum?: boolean };
  onSwitchForumTab: { id?: string };
}

interface IcustomEvents {
  emit: <K extends keyof PageModuleEventMap, V extends PageModuleEventMap[K]>(
    eventName: K,
    data: V
  ) => void;
  on: <
    K extends keyof PageModuleEventMap,
    V extends PageModuleEventMap[K],
    F extends (data: V) => void
  >(
    eventName: K,
    callback: F
  ) => void;
  off: <
    K extends keyof PageModuleEventMap,
    V extends PageModuleEventMap[K],
    F extends (data: V) => void
  >(
    eventName: K,
    callback: F
  ) => void;
}

const customEvents: IcustomEvents = {
  on: (eventName, callback) => {
    eventBus.on(eventName, callback);
  },
  off: (eventName, callback) => {
    eventBus.off(eventName, callback);
  },
  emit: (eventName, data) => {
    eventBus.emit(eventName, data);
  },
};

export default customEvents;
